// extracted by mini-css-extract-plugin
module.exports = {"container":"ResumeModale_container__2L44F","col-2":"ResumeModale_col-2__2voUG"};